import { Box, Divider, Grid, Typography } from "@mui/material";
import PlayerBox from "../PlayerBox";
import {
  byeBoxSx,
  getByeSx,
  getPairingSx,
  getRoundNoSx,
  pairingBoxSx,
  pairingTypographySx,
  roundLabelSx,
} from "./styles";

const Bracket = ({
  podNum,
  rounds,
  theme,
  event,
  hoverPlayer,
  pairings,
  setHoverPlayer,
  hasRematch,
  isFirstRound = false,
  headerText = "",
}) => {
  const keys = Object.keys(rounds);

  if (!keys.length && !isFirstRound) return "";

  return (
    <>
      <Typography variant="h4">{headerText}</Typography>
      <Grid item container sx={{ gap: 2, flexWrap: "unset", mb: 2 }}>
        {keys.map((roundNo, index) => {
          const round = rounds[roundNo];
          const isLastRound = keys.length === index + 1;
          const iSecondLastRound = keys.length === index;
          const roundPairingCount = round?.pairings?.length;
          const nextRound = rounds[parseInt(roundNo) + 1];
          const nextRoundPairingCount = nextRound?.pairings?.length;

          return (
            <Grid
              item
              key={roundNo}
              sx={getRoundNoSx(
                isLastRound,
                theme,
                roundPairingCount > 1 &&
                  roundPairingCount !== nextRoundPairingCount
              )}
            >
              <Typography variant="h4" sx={roundLabelSx}>
                {round?.label || "----"}
              </Typography>

              {round?.bye ? (
                <Box key={index} sx={getByeSx(roundNo, theme)}>
                  <Box sx={byeBoxSx}></Box>
                </Box>
              ) : (
                <>
                  {round?.pairings?.map((pairing, index) => {
                    return (
                      <Box
                        key={index}
                        className="pairingWrapper"
                        sx={getPairingSx(
                          roundNo,
                          event.podRound + (round?.podNum === 2 ? 1 : 0),
                          theme
                        )}
                      >
                        <Box sx={pairingBoxSx}>
                          <Typography
                            variant="caption"
                            sx={pairingTypographySx}
                          >
                            {event?.doubleElimination &&
                            ((iSecondLastRound && hasRematch) ||
                              (isLastRound && !hasRematch))
                              ? "CB Final"
                              : podNum === 1 &&
                                isLastRound &&
                                event?.doubleElimination
                              ? "Potential Rematch"
                              : isLastRound
                              ? "Final"
                              : `${roundNo}.${pairing?.bracketPairingNum}`}
                          </Typography>

                          <PlayerBox
                            roundNo={roundNo}
                            round={round}
                            pairing={pairing}
                            playerNo="player1"
                            sx={{ mt: 1 }}
                            hoverPlayer={hoverPlayer}
                            pairings={pairings}
                            setHoverPlayer={setHoverPlayer}
                            startRoundNumber={event.podRound || 1}
                          />

                          <Divider />

                          <PlayerBox
                            roundNo={roundNo}
                            round={round}
                            pairing={pairing}
                            playerNo="player2"
                            sx={{}}
                            hoverPlayer={hoverPlayer}
                            pairings={pairings}
                            setHoverPlayer={setHoverPlayer}
                            startRoundNumber={event.podRound || 1}
                          />
                        </Box>
                      </Box>
                    );
                  })}
                </>
              )}
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default Bracket;
